import { render, staticRenderFns } from "./DecisionCardHeader.vue?vue&type=template&id=70cb4da0&scoped=true&"
import script from "./DecisionCardHeader.vue?vue&type=script&lang=ts&"
export * from "./DecisionCardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionCardHeader.vue?vue&type=style&index=0&id=70cb4da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb4da0",
  null
  
)

export default component.exports